import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClasseProduto } from '../classes/ClasseProduto';

@Injectable({
  providedIn: 'root'
})
export class ClasseProdutoService {

  constructor(private http: HttpClient) { }

  getClassesProduto(): Observable<any>{
    return this.http.get(`${environment.apiURL}/classeProduto`)
  }

  getClasseProduto(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/classeProduto/${id}`)
  }

  postClasseProduto(classeProduto: ClasseProduto): Observable<any>{
    return this.http.post(`${environment.apiURL}/classeProduto`, classeProduto);
  }

  putClasseProduto(id: number, classeProduto: ClasseProduto): Observable<any>{
    return this.http.put(`${environment.apiURL}/classeProduto/${id}`, classeProduto);
  }

  deleteClasseProduto(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/classeProduto/${id}`);
  }
}
